// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-action-menu {
  position: fixed;
  z-index: 9999;
  min-width: 120px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.card-action-menu__list {
  list-style: none;
  margin: 0;
  padding: 4px 0;
}

.card-action-menu__option {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 12px;
  border: none;
  background: none;
  cursor: pointer;
  text-align: left;
  font-size: 14px;
  color: #1e293b;
  transition: background-color 0.15s ease;
}

.card-action-menu__option:hover {
  background-color: #f1f5f9;
}

.card-action-menu__option--danger {
  color: #dc2626;
}

.card-action-menu__option--danger:hover {
  background-color: #fef2f2;
}

.card-action-menu__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
}

.card-action-menu__label {
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/page-layout/Card/CardActionMenu.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,OAAO;AACT","sourcesContent":[".card-action-menu {\n  position: fixed;\n  z-index: 9999;\n  min-width: 120px;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  overflow: hidden;\n}\n\n.card-action-menu__list {\n  list-style: none;\n  margin: 0;\n  padding: 4px 0;\n}\n\n.card-action-menu__option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 8px 12px;\n  border: none;\n  background: none;\n  cursor: pointer;\n  text-align: left;\n  font-size: 14px;\n  color: #1e293b;\n  transition: background-color 0.15s ease;\n}\n\n.card-action-menu__option:hover {\n  background-color: #f1f5f9;\n}\n\n.card-action-menu__option--danger {\n  color: #dc2626;\n}\n\n.card-action-menu__option--danger:hover {\n  background-color: #fef2f2;\n}\n\n.card-action-menu__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n}\n\n.card-action-menu__label {\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
